import type { FunctionComponent, ReactElement } from 'react';

import Button from '../../ui/button/button';

import styles from './no_content_panel_compact.module.css';

const formatPath = (path?: string) => (path || '').replace('?embeddable', '');

type Props = {
  title: string;
  linkHref?: string;
  linkText?: string;
  actionText?: string;
  onActionClick?: () => void;
  actionElement?: ReactElement;
  disableActionButton?: boolean;
};

export const NoContentPanelCompact: FunctionComponent<Props> = (props) => {
  const {
    title,
    linkHref,
    linkText,
    onActionClick,
    actionText,
    actionElement,
    disableActionButton,
  } = props;

  return (
    <div className={styles.root} role="region" aria-label="No content">
      <p className={styles.message}>{title}</p>
      {linkHref && linkText ? (
        <a
          className={styles.link}
          href={formatPath(linkHref)}
          target="_blank"
          rel="noreferrer"
        >
          {linkText}
        </a>
      ) : null}
      {actionElement}
      {!actionElement && onActionClick && actionText ? (
        <Button
          className={styles.action_element}
          onClick={() => onActionClick()}
          disabled={disableActionButton}
        >
          {actionText}
        </Button>
      ) : null}
    </div>
  );
};
